import { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useNavigate } from "react-router-dom";
import { usePersistentState } from "../../contexts/global-context";
import Color from "../../theme/color";
import TableContainer from "@mui/material/TableContainer";
import moment from "moment";
import { Skeleton, Typography } from "@mui/material";
import NumberFormat from "../../components/number-format";
import {
  convertLocalDateToUTCIgnoringTimezone,
  findDateDiff,
} from "../../components/date-time-validation";
import { useIsInViewport } from "../../hooks/element-is-visible";

export const TicketCard = () => {
  const navigate = useNavigate();
  const ref: any = useRef();
  const isInViewport = useIsInViewport(ref);
  const [state, dispatch]: any = usePersistentState();
  const [validationError, setValidationError] = useState<string | null>(null);
  const EventTicketConfigDetails = state?.EventTicketConfig;
  const EventVenueDetails: any = state?.EventVenue;
  const [ticketQuantities, setTicketQuantities] = useState(
    EventTicketConfigDetails
      ? Array(EventTicketConfigDetails.length).fill(0)
      : Array(10).fill(0)
  );

  useEffect(() => {
    dispatch({ EventId: state?.Event?.id });
    setTimeout(() => {
      dispatch({ EventId: state?.Event?.id });
    }, 1500);
  }, []);
  useEffect(() => {
    dispatch({ isInViewport: isInViewport });
  }, [isInViewport]);

  if (EventTicketConfigDetails) {
    for (let i = 0; i < EventTicketConfigDetails.length; i++) {
      if (typeof ticketQuantities[i] === "undefined") {
        setTicketQuantities((prevQuantities: any) => [
          ...prevQuantities.slice(0, i),
          0,
          ...prevQuantities.slice(i + 1),
        ]);
      }
    }
  }

  const handleIncrementQuantity = async (index: any) => {
    const newQuantities = [...ticketQuantities];
    newQuantities[index] += 1;
    setTicketQuantities(newQuantities);
  };

  const handleDecrementQuantity = (index: any) => {
    if (ticketQuantities[index] > 0) {
      const newQuantities = [...ticketQuantities];
      newQuantities[index] -= 1;
      setTicketQuantities(newQuantities);
    }
  };

  const handleBuyTicket = () => {
    const totalTicketCount = ticketQuantities.reduce((total: any, quantity: any) => total + quantity, 0);
    // debugger;
    if (totalTicketCount < 1) {
      setValidationError("At least one ticket is required.");
    } else {
      let temp = EventTicketConfigDetails?.map((x: any, index: number) => {
        if (ticketQuantities[index] !== 0) {
          let amount = x?.price * ticketQuantities[index];
          return { ...x, qty: ticketQuantities[index], amount: amount };
        }
      });
      let final = temp.filter(function (element: any) {
        return element !== undefined;
      });
      let newData = {
        final,
        totalTicketPrices,
        ticketQuantities,
      };
      dispatch({ CheckOutData: newData });
      let CheckOutDataEventDetail = {
        eventId: state?.Event?.id,
        Event: state.Event,
      };
      localStorage.setItem("CheckOutData", JSON.stringify(newData));
      localStorage.setItem(
        "CheckOutDataEventDetail",
        JSON.stringify(CheckOutDataEventDetail)
      );

      setValidationError(null);
      navigate("/checkout", {
        state: {
          data: newData,
          eventId: state?.Event?.id,
          Event: state.Event,
        },
      });
    }
  };

  const calculateTotalPrice = () => {
    if (EventTicketConfigDetails.length > 0) {
      let totalPrice = 0;
      EventTicketConfigDetails?.forEach((item: any, index: any) => {
        totalPrice += item.price * ticketQuantities[index];
      });
      return totalPrice;
    }
    return 0;
  };

  const totalTicketPrices = calculateTotalPrice();

  return (
    <section id="resume">
      <Grid item xs={12} sm={12} md={12}>
        <CardContent style={{ padding: 0 }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontSize: "18px", color: Color.color22 }}>
                    Ticket Type
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "18px",
                      color: Color.color22,
                      textAlign: "center",
                    }}
                  >
                    Quantity
                  </TableCell>
                  <TableCell style={{ fontSize: "18px", color: Color.color22 }}>
                    Price
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {EventTicketConfigDetails?.length > 0 ? (
                  EventTicketConfigDetails?.map((data: any, index: any) => {
                    const availableQty = data.quantity - data?.soldOut;

                    const currentUTCDate: Date | null =
                      convertLocalDateToUTCIgnoringTimezone(new Date());

                    let startDateDiff = null;
                    let endDateDiff = null;
                    if (data?.saleStartDateUtc) {
                      startDateDiff = findDateDiff(
                        new Date(data?.saleStartDateUtc),
                        currentUTCDate
                      );
                    }

                    if (data?.saleEndDateUtc) {
                      endDateDiff = findDateDiff(
                        new Date(data?.saleEndDateUtc),
                        currentUTCDate
                      );
                    }

                    return (
                      <TableRow key={index}>
                        <TableCell
                          style={{
                            fontSize: "16px",
                            color: Color.color21,
                            flexDirection: "column",
                          }}
                        >
                          <Typography
                            style={{
                              fontSize: "14px",
                              color: "#8c8c8c",
                              display: "block",
                              fontWeight: "bold",
                            }}
                          >
                            {data?.ticketType}
                          </Typography>
                          <Typography
                            style={{
                              fontSize: "14px",
                              color: "#8c8c8c",
                              display: "block",
                            }}
                          >
                            {data?.description}
                          </Typography>
                        </TableCell>

                        <TableCell
                          style={{
                            fontSize: "16px",
                            color: Color.color21,
                            textAlign: "center",
                          }}
                        >
                          <div>
                            <IconButton
                              sx={{ color: Color.red }}
                              onClick={() => handleDecrementQuantity(index)}
                              disabled={
                                data.isSoldOut || ticketQuantities[index] === 0
                              }
                            >
                              -
                            </IconButton>

                            {ticketQuantities[index]}

                            <IconButton
                              sx={{ color: Color.green }}
                              disabled={
                                data.isSoldOut ||
                                data?.saleStartDateUtc === !null ||
                                data?.saleEndDateUtc === !null ||
                                (data?.perOrderLimit === 0 ||
                                data?.perOrderLimit === null
                                  ? null
                                  : ticketQuantities[index] ===
                                    data?.perOrderLimit) ||
                                0 < endDateDiff?.dateDiff ||
                                0 > startDateDiff?.dateDiff ||
                                ticketQuantities[index] >= availableQty ||
                                availableQty > data?.quantity
                              }
                              onClick={() => handleIncrementQuantity(index)}
                            >
                              +
                            </IconButton>
                          </div>

                          {data.soldOut >= data?.quantity || data.isSoldOut ? (
                            <span style={{ color: "red" }}>Sold out</span>
                          ) : (
                            <>
                              {ticketQuantities[index] >= availableQty ? (
                                <span style={{ color: "red" }}>
                                  Limit exceeded
                                </span>
                              ) : (
                                <>
                                  {0 <= endDateDiff?.dateDiff && (
                                    <span style={{ color: "red" }}>
                                      Sale ended
                                    </span>
                                  )}
                                  {0 >= startDateDiff?.dateDiff && (
                                    <span style={{ color: "Green" }}>
                                      Sale starts from{" "}
                                      {moment(data?.saleStartDate).format(
                                        "MMM Do YYYY, h:mm A"
                                      )}
                                      (
                                      {
                                        EventVenueDetails?.timeZone
                                          ?.abbreviation
                                      }
                                      )
                                    </span>
                                  )}
                                  {data?.perOrderLimit === 0 ||
                                  data?.perOrderLimit === null ? null : (
                                    <>
                                      {ticketQuantities[index] ===
                                        data?.perOrderLimit && (
                                        <span style={{ color: "red" }}>
                                          Only {data?.perOrderLimit} ticket/s
                                          allowed per order
                                        </span>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </TableCell>
                        <TableCell style={{ fontSize: "16px", color: "#666" }}>
                          {data.price === 0 ? (
                            "Free"
                          ) : (
                            <>
                              $<NumberFormat total={data.price} />
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <div style={{ marginLeft: "10px", marginTop: "15px" }}>
                    <Skeleton
                      variant="text"
                      sx={{ fontSize: "1rem", width: "300px" }}
                    />
                    <Skeleton
                      variant="text"
                      sx={{ fontSize: "1rem", width: "550px" }}
                    />
                  </div>
                )}
                <TableRow>
                  <TableCell
                    style={{
                      fontSize: "18px",
                      color: "#333",
                      fontWeight: "bold",
                      width: "40%",
                    }}
                  >
                    Subtotal
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "18px",
                      color: "#333",
                      fontWeight: "bold",
                      textAlign: "center",
                      width: "40%",
                    }}
                  >
                    {ticketQuantities.reduce(
                      (total: any, quantity: any) => total + quantity,
                      0
                    )}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "18px",
                      color: "#333",
                      fontWeight: "bold",
                      width: "20%",
                    }}
                  >
                    $<NumberFormat total={totalTicketPrices} />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          {validationError && (
            <div>
              <Typography style={{ color: "red" }}>
                {validationError}
              </Typography>
            </div>
          )}
          <div style={{ display: "flex", marginTop: "15px" }}>
            <Button ref={ref} style={{ width: "100%", backgroundColor: Color.primary }} variant="contained" size="large" onClick={handleBuyTicket}>
              Buy Ticket
            </Button>
          </div>
        </CardContent>
      </Grid>
    </section>
  );
};
